import { render, staticRenderFns } from "./RankTab.vue?vue&type=template&id=36be0997&scoped=true&"
import script from "./RankTab.vue?vue&type=script&lang=js&"
export * from "./RankTab.vue?vue&type=script&lang=js&"
import style0 from "./RankTab.vue?vue&type=style&index=0&id=36be0997&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be0997",
  null
  
)

export default component.exports